import { render, staticRenderFns } from "./SortData.vue?vue&type=template&id=e9f41c6a&"
import script from "./SortData.vue?vue&type=script&lang=js&"
export * from "./SortData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports